var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9745 11.8432C12.9508 10.9581 12.2188 8.60626 12.2188 5.84377C12.2188 3.75276 10.8747 1.97998 9.00471 1.3308C8.8788 0.576407 8.22749 0 7.43751 0C6.64755 0 5.99623 0.576407 5.87031 1.33078C4.00031 1.97996 2.65626 3.75276 2.65626 5.84377C2.65626 8.60575 1.92473 10.957 0.900473 11.8432C0.328854 12.3378 0 13.056 0 13.8125C0 14.6928 0.713466 15.4063 1.59374 15.4063H5.84374C5.84374 16.2865 6.55721 17 7.43748 17C8.31776 17 9.03122 16.2865 9.03122 15.4063H13.2812C14.1615 15.4063 14.875 14.6928 14.875 13.8125C14.875 13.0566 14.5467 12.3378 13.9745 11.8432ZM1.59374 13.8125C1.59374 13.5193 1.72125 13.2404 1.94277 13.0486C3.36598 11.8182 4.24998 9.05728 4.24998 5.84374C4.24998 4.08584 5.67958 2.65623 7.43748 2.65623C9.19538 2.65623 10.625 4.08584 10.625 5.84374C10.625 9.05728 11.509 11.8182 12.9322 13.0486C13.1543 13.2409 13.2812 13.5192 13.2812 13.8125H1.59374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.2afadebc31ee1870d6c9031c306d078f.svg";
export { ForwardRef as ReactComponent };